/** Cross-app URLs for Kinora account hats (P2-5). */
export const VIEWER_URL =
  import.meta.env.VITE_VIEWER_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');
export const GUILD_URL = import.meta.env.VITE_GUILD_URL || 'http://localhost:3002';
export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'http://localhost:3004';

/** @deprecated Use GUILD_URL from this module. */
export { GUILD_URL as defaultGuildUrl };
